import {iContent} from "@/Engine/apiInterfaces";
import {Item} from "@/Engine/Item";
import {Vector3} from "three";
import {modelMeta} from "@/Constants/modelMeta";

export class Wall extends Item {

    constructor(props: iContent, color: string, width: number) {
        super(props);
        this.setColor(color);
        if (props.blender_name === 'ml_1500') {
            this.position = new Vector3(width/2-0.014, 0.058, 0.016)
        } else {
            this.position = new Vector3(width/2-0.014, 0.272, 0.016)
        }
    }
}
